<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Edit Link</modal-header>
        </div>
        <div>
          <form-group>
            <field name="Name" :value="name" v-model="name" />
          </form-group>
        </div>
      <div v-if="allowEditPassword">
        <span class="label-text">URL </span><br>
        <div>
          <a class="preview-link" :href="previewUrl(confirmId)" target="_blank">{{ previewUrl(confirmId) }}</a>
          <button-cta title="copy to clipboard"
                      data-type="preview_url"
                      :onClick="copySingle"
                      class="btn btn-success btn-xs">
            <i class="fa fa-copy" aria-hidden="true"></i>
          </button-cta>
        </div>
        <div class="btn-group">
          <br>
          <span class="label-text">Password </span><br>
          <span class="password-text">
<!--              {{ decodePassword(responseData.password) }}-->
            {{ oldPassword}}
              <button-cta title="copy to clipboard"
                          data-type="password"
                          :onClick="copySingle"
                          class="btn btn-success btn-xs">
              <i class="fa fa-copy" aria-hidden="true"></i>
            </button-cta>
            </span>
        </div>
        <br>
        <br>
        <a href="javascript:;" @click="enableEditPassword">{{ isPasswordEditing? 'Cancel edit password' : 'Edit password'}}</a>
        <form-group v-if="isPasswordEditing">
          <field name="Password" :value="password" v-model="password" />
          <small class="password-error" v-if="passwordError">
            {{passwordError}}
          </small>
          <small >
            <a href="javascript:;" @click="generatePassword">Auto generate password</a>
          </small>
        </form-group>
      </div>
      <div v-if="isCopied" class="alert alert-success" role="alert" id="copiedAlert">
        <p>Information has been copied to clipboard!</p>
      </div>
        <div slot="modalFooter">
          <modal-footer v-if="allowEditPassword" :confirmTheme="'primary'" :hideCancelText="true" confirmText="Copy URL and Password" :confirm="copyToClipboard" />
          <modal-footer :closeModal="close" :confirm="confirm"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import {modalMixin} from '@/mixins/modalMixin'
import {linkMixin} from '@/mixins/linkMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {API_URL} from '@/config'

export default {
  name: 'modal_edit_link',
  mixins: [modalMixin, linkMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String,
    linkType: String,
    allowEditPassword: { type: Boolean, default: false },
    oldPassword: String
  },
  data: () => ({
    name: '',
    password: '',
    isPasswordEditing: false,
    passwordError: null,
    isCopied: false
  }),
  mounted () {
    this.name = this.field
  },
  computed: {},
  methods: {
    confirm () {
      if (this.isPasswordEditing && this.password.trim().length < 8) {
        this.passwordError = 'Password is required and min length is 8 characters'
        const timerId = setTimeout(() => {
          clearTimeout(timerId)
          this.passwordError = null
        }, 8000)
        return
      }
      this.startLoading()
      const data = {
        id: this.confirmId,
        name: this.name,
        password: this.allowEditPassword && this.isPasswordEditing ? this.password : null
      }
      this.updateLink(data).then(() => {
        this.addNotification('success', 'Link updated.')
        this.getLinks(this.linkType).then(() => {
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    },
    enableEditPassword () {
      this.isPasswordEditing = !this.isPasswordEditing
      if (!this.isPasswordEditing) {
        this.password = ''
      }
    },
    generatePassword () {
      const length = 8
      const charset = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let retVal = ''
      for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n))
      }
      this.password = retVal
    },
    previewUrl (hashId) {
      const path = `/review/${hashId}`
      return API_URL + path.substring(1)
    },
    clipboard (value) {
      const el = document.createElement('textarea')
      el.value = value

      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected =
          document.getSelection().rangeCount > 0
            ? document.getSelection().getRangeAt(0)
            : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.isCopied = true
      setTimeout(() => {
        this.isCopied = false
      }, 10000)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
    },
    copyToClipboard () {
      let value = ''
      value = `URL: ${this.previewUrl(this.confirmId)}\nPassword: ${this.oldPassword}`
      this.clipboard(value)
    },
    copySingle (evt) {
      const {type} = evt.currentTarget.dataset
      let value = ''
      if (type === 'password') {
        value = this.oldPassword
      } else {
        value = this.previewUrl(this.confirmId)
      }
      this.clipboard(value)
    }
  },
  watch: {
    field: function () {
      this.name = this.field
    }
  }
}
</script>

<style lang="scss">
.password-error{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/links/modal-edit-link.vue